export class PropertyAttachmentDTO{
    public attachmentType!: number; //1=image, 2=document
    public id?: number;
    public type!: number; //used for documents
    public reference!: string; //URL path for attachment
    public sequenceNo!: number; //used for images
    //images: listing frame (relative 0..1, all null = whole image centered) and fit (0 = fill the box, 1 = whole frame/image)
    public frameX?: number | null;
    public frameY?: number | null;
    public frameW?: number | null;
    public frameH?: number | null;
    public fitMode?: number;

    constructor(){

    }
}
